import React from "react";
import { useNavigate } from "react-router-dom";
import { useLang } from "../../context/LanguageContext";
import { LanguageSwitcher } from "../common/LanguageSwitcher";
import { Menu, Search, Bell, LogOut, UserCircle2 } from "lucide-react";
import {
  DropdownMenu, DropdownMenuContent, DropdownMenuItem,
  DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger,
} from "../ui/dropdown-menu";

export const TopBar = ({ onMenuClick }) => {
  const { t } = useLang();
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.removeItem("sarbajaya_demo_session");
    navigate("/login");
  };

  return (
    <header className="sticky top-0 z-30 border-b border-emerald-950/10 bg-white/90 backdrop-blur-md">
      <div className="flex h-16 items-center gap-3 px-4 sm:px-6">
        <button
          type="button"
          onClick={onMenuClick}
          data-testid="topbar-menu-btn"
          className="rounded-lg p-2 text-emerald-900/70 hover:bg-emerald-900/5 lg:hidden"
          aria-label="Open menu"
        >
          <Menu className="h-5 w-5" />
        </button>

        <div className="hidden min-w-0 flex-1 md:block">
          <div className="flex items-center gap-2 text-xs text-emerald-900/60">
            <span className="hidden sm:inline">{t.appSubtitle}</span>
          </div>
        </div>

        {/* Search */}
        <div className="relative hidden flex-1 md:block md:max-w-md">
          <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-emerald-900/40" />
          <input
            type="search"
            placeholder={t.common.search}
            data-testid="topbar-search-input"
            className="h-9 w-full rounded-full border border-emerald-950/10 bg-[#F9F8F3] pl-9 pr-4 text-sm text-emerald-950 placeholder:text-emerald-900/40 focus:border-emerald-700 focus:bg-white focus:outline-none focus:ring-2 focus:ring-emerald-700/20"
          />
        </div>

        <div className="ml-auto flex items-center gap-2 sm:gap-3">
          <LanguageSwitcher />

          <button
            type="button"
            data-testid="topbar-notifications-btn"
            className="relative rounded-full border border-emerald-950/10 bg-white p-2 text-emerald-900/70 shadow-sm transition-colors hover:bg-emerald-900/5 hover:text-emerald-900"
            aria-label="Notifications"
          >
            <Bell className="h-4 w-4" />
            <span className="absolute right-1 top-1 h-2 w-2 rounded-full bg-[#D95D39] ring-2 ring-white" />
          </button>

          <DropdownMenu>
            <DropdownMenuTrigger asChild>
              <button
                data-testid="topbar-profile-btn"
                className="flex items-center gap-2 rounded-full border border-emerald-950/10 bg-white py-1 pl-1 pr-3 shadow-sm transition-colors hover:bg-emerald-900/5"
              >
                <span className="flex h-7 w-7 items-center justify-center rounded-full bg-emerald-900 text-xs font-bold text-white">
                  SD
                </span>
                <span className="hidden text-xs font-medium text-emerald-900 sm:inline">
                  Sunita D.
                </span>
              </button>
            </DropdownMenuTrigger>
            <DropdownMenuContent align="end" className="w-56 bg-white">
              <DropdownMenuLabel className="font-normal">
                <div className="font-display text-sm font-semibold text-emerald-950">Sunita Debbarma</div>
                <div className="mt-0.5 text-xs text-emerald-900/60">{t.common.role}</div>
              </DropdownMenuLabel>
              <DropdownMenuSeparator />
              <DropdownMenuItem data-testid="menu-profile">
                <UserCircle2 className="mr-2 h-4 w-4" />
                {t.common.profile}
              </DropdownMenuItem>
              <DropdownMenuSeparator />
              <DropdownMenuItem
                data-testid="menu-logout"
                onClick={handleLogout}
                className="text-rose-700 focus:bg-rose-50 focus:text-rose-800"
              >
                <LogOut className="mr-2 h-4 w-4" />
                {t.common.logout}
              </DropdownMenuItem>
            </DropdownMenuContent>
          </DropdownMenu>
        </div>
      </div>
    </header>
  );
};
